// autogenerated, do not modify

export default {
  "Axios.ConnectionError": "インターネット接続がありません。ネットワーク接続およびAPN設定をご確認ください。（APN設定欄には\"internet\"と入力が必要です。）",
  "Axios.Error": "Error {status}",
  "Axios.ServerError": "問題が発生したため復旧作業中です。時間を置いてから再度お試しください。",
  "Axios.TimeoutError": "サーバーが時間切れです。もう一度やり直してください。",
  "Common.Activate": "利用する",
  "Common.Activated": "ご利用中",
  "Common.AddNumberForSMS": "MTXナンバーを追加",
  "Common.Attention": "ご注意ください",
  "Common.Back": "戻る",
  "Common.Balance": "残高",
  "Common.CNY": "中国元",
  "Common.Cancel": "キャンセル",
  "Common.Close": "閉じる",
  "Common.ContactSupport": "サポートに連絡",
  "Common.Date": "日付",
  "Common.Deactivate": "利用を終了する",
  "Common.Delete": "削除",
  "Common.Duration": "期間",
  "Common.ESIM": "eSIM",
  "Common.EUR": "€",
  "Common.Europe": "ヨーロッパ",
  "Common.Everywhere": "どこでも",
  "Common.Friday": "金",
  "Common.IdentityUnverified": "身分証明書（パスポートや運転免許証など）の写真のアップロードが必要です。身分証の審査と承認後にサービスをご利用開始いただけます。",
  "Common.IdentityWanted": "本人確認書類（パスポートまたは運転免許証）写真のアップロードが必要です",
  "Common.IdentityWantedFlashMessage": "本人確認書類（パスポートまたは運転免許証）の <a href=\"{link}\">アップロード</a> が必要です",
  "Common.Loading": "読み込み中...",
  "Common.Login": "ログイン",
  "Common.MB": "MB",
  "Common.Mb": "Mb",
  "Common.Monday": "月",
  "Common.Name": "名前",
  "Common.Next": "次へ",
  "Common.NoData": "データがありません",
  "Common.Ok": "OK",
  "Common.Package": "プラン",
  "Common.Price": "価格",
  "Common.SIM": "SIM",
  "Common.Saturday": "土",
  "Common.Save": "保存",
  "Common.Simcard": "SIMカード",
  "Common.Sum": "合計",
  "Common.Sunday": "日",
  "Common.Thursday": "木",
  "Common.Traffic": "データ利用量",
  "Common.Tuesday": "火",
  "Common.Wednesday": "水",
  "Common.day": "日",
  "Common.hour": "時間",
  "Common.minute": "分",
  "Exception.LetUsKnow": "お問い合わせください",
  "Exception.PageNotFound": "ページが見つかりません。404",
  "Exception.ReturnToHomepage": "トップページに戻ってください",
  "Exception.ServerErrorDescription": "もう一度やり直してください。やり直しても問題が解決しない場合はお問い合わせください。",
  "Exception.ServerErrorTitle": "問題が発生しました",
  "GDPR.AgreeBtn": "GIVE CONSENT",
  "GDPR.Attention": "Please not that in case you refuse to accept the new Privacy Policy we will not be able to provide you with our Services subject to the new regulations of the European Union.",
  "GDPR.BackLink": "Back to MTX Connect website",
  "GDPR.DisagreeBtn": "Do not give consent",
  "GDPR.Notice": "In accordance with new requirements regarding the data protection in the European Union we are updating {link} in order to protect the privacy of our customers on higher standards and to improve the security of all personal data collected from you. The amendments will help you to understand what information we may collect about you and the reasons why we are doing so; it will also give you an overview on how you can manage, update, delete or export your information.",
  "GDPR.NoticeLink": "our Privacy Policy",
  "GDPR.Request": "We kindly ask you to carefully read {link} and provide us with your consent by clicking the button below.",
  "GDPR.RequestLink": "our amended Privacy Policy",
  "GDPR.VerificationTitle": "Thank you very much for giving us your consent.",
  "History.All": "すべて",
  "History.Date": "日付",
  "History.Details": "詳細",
  "History.DownloadReceipt": "get receipt",
  "History.EmptyHistory": "お支払履歴はありません",
  "History.EndDate": "終了日",
  "History.StartDate": "開始日",
  "History.Sum": "合計",
  "LogoutButton.Logout": "ログアウト",
  "LogoutButton.LogoutCancel": "キャンセル",
  "LogoutButton.LogoutConfirmation": "ログアウトしますか？",
  "LogoutButton.LogoutYes": "はい",
  "Menu.ActivateSIM": "新しいSIMの追加",
  "Menu.Connect": "プラン",
  "Menu.ContactUs": "お問い合せ",
  "Menu.Coverage": "ご利用可能エリア",
  "Menu.Faq": "よくあるご質問",
  "Menu.History": "履歴",
  "Menu.HowItWorks": "ご利用の流れ",
  "Menu.Overview": "概要",
  "Menu.Pricing": "価格",
  "Menu.Profile": "プロフィール<br />",
  "Menu.Support": "サポート<br />（英語・中国語）",
  "Menu.Topups": "チャージ",
  "OneTIme.PaymentSuccess": "Payment successful.",
  "OneTime.Amount": "Amount",
  "OneTime.EsimSentTo": "eSIM settings were also sent to:",
  "OneTime.OrderID": "Order ID:",
  "OneTime.PaidWith": "Paid with",
  "OneTime.ThankYou": "Thank you for purchasing!",
  "OneTime.WaitingEsim": "Your eSIM installation QR code will be ready in 1-2 minutes",
  "OneTimePassBuyTitle": "You are going to buy One-Time Pass offer: <b>{name}</b>",
  "OneTimePassDescription": "This eSIM is for **one-time use only**. It will deactivate once its package is used up or expires, and it cannot be reused like a regular MTX eSIM.\n\nIt won't be visible in your MTX personal account, meaning you can't manage it there.\n\n\\\n**How to use One-time Pass:**\n1. You will get a QR code.\n2. Scan it with your phone.\n3. Follow the on-screen instructions.",
  "OneTimePassDisclaimerMsg": "New disposable eSIM will be installed. It will deactivate once it's used or expired.",
  "OneTimePassDisclaimerTitle": "ONE-TIME PASS OFFERS",
  "OneTimePassLoadingMsg": "We are looking for available One-Time offers, which can take up to 2 minutes. Please be patient.",
  "OneTimePassMissingCoverage": "We are constantly working to expand our coverage. Unfortunately, we currently do not have One-Time Pass offers in {country}.",
  "Order.Acknowledge": "Acknowledge",
  "Order.Activate": "新規SIMをアクティベーションする",
  "Order.ActivationCode": "アクティベーションコード",
  "Order.Attention": "本サービスのご利用には残高チャージが必要です",
  "Order.AttentionCanada": "Attention: MTX Connect service cannot be used for domestic service in Canada by residents of Canada.",
  "Order.AttentionChina": "For shipment to mainland China, we need your mobile phone number, and the shipping address in Chinese character.",
  "Order.CartCaption": "ご注文は {name} card {amount} 枚, 合計 €{price}",
  "Order.ChooseOption": "オプションを選択してください",
  "Order.ChooseType": "SIMカードタイプを選択する",
  "Order.CloseBtn": "閉じる",
  "Order.Continue": "ここから先に進むことで、お客様は弊社の規約と条件 <a href=\"https://www.mtxc.eu/en/terms-and-conditions.html\" target=\"_blank\">Terms and Conditions</a> およびプライバシーポリシー <a href=\"https://www.mtxc.eu/en/privacy-policy.html\" target=\"_blank\">Privacy Policy</a> に同意したものとみなされます",
  "Order.DontDeleteEsim": "注意ください！eSIMは削除しないでください。一度削除すると元に戻すことができません。一時的にプロファイルをディアクティベート（無効化）、再アクティベートをすることで、eSIMを削除することなくご利用いただけます。",
  "Order.DontDeleteEsimLink": "https://mtxchelp.crisp.help/en-us/article/what-do-i-do-if-i-delete-my-esim-tagfxh/",
  "Order.DontDeleteEsimLinkName": "(常见问题)",
  "Order.ESIMConfirmation": "わたしのデバイスはeSIM対応であることを確認しました",
  "Order.ESIMDescr": "eSIM対応デバイス用eSIM、€{price} *",
  "Order.EsimCanProcess": "eSIMデータのダウンロードには最大２分ほどかかることがあります",
  "Order.EsimRequestRateExceeded": "定時間に処理できる注文数には限りがあります。さらに注文する必要がある場合はしばらくお待ちください。",
  "Order.EsimSent": "eSIMの設定方法がメールアドレスに送信されます。このウィンドウは閉じても構いません。",
  "Order.MakeSureEsim": "お手持ちのデバイスがeSIM対応であることをご確認ください。eSIM対応可否はお手持ちのスマートフォンのユーザマニュアルまたは製造メーカーのウェブサイトから確認ができます。デバイスがeSIM対応ではない場合、本サービスはご利用いただけません。",
  "Order.MaxLengthExceeded": "Field {fieldName} is limited to {maxLength} characters",
  "Order.New": "新規SIMを注文する",
  "Order.OrderID": "注文ID：{orderId}",
  "Order.PaymentDescr": "*お支払いはお客様のMTX Connect残高より差し引かれます",
  "Order.ProceedWithOrder": "and proceed with order",
  "Order.QuotaExceededCheckbox": "Got it",
  "Order.QuotaExceededConfirmation": "You won't be able to activate a card on this account because you already have 10 active cards. <br /><br />If you need more, you can create one more account or contact <a href=\"mailto:corp@mtxc.eu\">corp@mtxc.eu</a>. We'll offer you the best solution for managing a larger number of cards.",
  "Order.SIMDescr": "3-in-1 SIMカード、€{price}",
  "Order.SimcardsLimitExceeded": "You have ten active cards in your account.<br /><br />If you need more, you can create one more account or contact <a href=\"mailto:corp@mtxc.eu\">corp@mtxc.eu</a>. We'll offer you the best solution for managing a larger number of cards.",
  "Order.SmdpAddress": "SM-DP+ アドレス",
  "Order.SuccPaymentCaption": "お支払いが完了しました。注文を受け付けました。",
  "Order.SuccPaymentDescr": "注文受付完了メールが送信されます {orderCaption}",
  "Order.UnsuccPaymentCaption": "お支払いが完了しませんでした",
  "Overview.ForSelectedCard": "For selected card only",
  "Overviews.Action": "アクション",
  "Overviews.ActivationCodeUsed": "アクティベーションコード &laquo;<strong>{code}</strong>&raquo; のSIMカードのアクティベーションが完了しました。",
  "Overviews.ActiveSince": " {date} よりご利用中",
  "Overviews.Date": "日付",
  "Overviews.Details": "詳細",
  "Overviews.Left": "残",
  "Overviews.NoActivePackage": "現在ご利用中の<br />プランは<br />ありません",
  "Overviews.NoAvailableTraffic": "ご利用可能なデータ量はありません",
  "Overviews.NoTimeLeft": "プランは期限切れです",
  "Overviews.Remain": "残り",
  "Overviews.RemainOf": "残 {remain}",
  "Overviews.Spent": "利用済",
  "Overviews.TrafficLeft": "データ残量",
  "Overviews.TrafficUsageHistory": "データ利用履歴",
  "Overviews.UnlimitedTime": "時間無制限",
  "Overviews.UnlimitedTraffic": "データ無制限",
  "Overviews.UsageHistory": "ご利用履歴",
  "Package.Accept": "はい",
  "Package.Active": "ご利用中",
  "Package.AnotherPackageIsActive": "現在 {activePackageName} プランをご利用中です。ご利用中のプランが終了するまでお待ちください。",
  "Package.AutomaticRenewal": "Automatic renewal",
  "Package.AvailableCountries": "対応国",
  "Package.AvailableNumbers": "対応番号",
  "Package.Back": "戻る",
  "Package.BundlesLoadFailure": "プランリストを読み込めませんでした",
  "Package.CancelRenewal": "更新をキャンセル",
  "Package.CannotSwitchTariff": "プランをご利用開始できません",
  "Package.ConfirmActivation": "<div>SIMカード {cardName} で <b>{packageName}</b> プランの利用を開始します</div>",
  "Package.ConfirmActivationMobileNumber": "<div>SIMカード {cardName} で<b>MTX Number ナンバーサブスクリプション</b>をアクティベートします。</div>",
  "Package.ConfirmActivationSubscription": "<div>お客様のアカウントに<b>{packageName}</b>をアクティベートします。<br /><b>フリーチャットオプションはこのカード: {cardName}に適用されます。</b><br />別のSIMカードでフリーチャットを希望される方は、いいえを押して、別のカードを選択後に<b>{packageName}</b>をアクティベートしてください。</div>",
  "Package.ConfirmAgreeCheckbox": "理解の上、同意します。",
  "Package.ConfirmAgreeText": "MTXナンバーサービスの契約期間は自動更新となっています。最初にご契約いただいた設定期間と同期間、自動更新し続けます。お客様のアカウント残高を利用しての更新となるため、ナンバーサービスの更新期限前にアカウント残高が十分あることをお確かめください。\n\nお客様のお支払いをもって、下記に同意されたものとみなします：MTXナンバーは固定電話に代わるサービスではないため、緊急通報にはご利用いただけません。\n\nこのサービスは「現状有姿」で提供されるため、一部のモバイルネットワーク、アプリケーション、またはその他サードパーティのサービスからのSMSが届かない場合があります。MTX Connectは、MTXサービスの適合性またはユーザビリティについて、明示的であれ黙示的であれ、いかなる保証もいたしません。本サービスのご購入後の返金はできません。",
  "Package.ConfirmAlertConsent": "Please confirm the purchase of <b>MTX Number for SIM card</b> {cardName}.",
  "Package.ConfirmAndPay": "確認の上、支払う。",
  "Package.ConfirmDeactivation": "<div>SIMカード {cardName} で <b>{packageName}</b> プランの利用を終了します </div>",
  "Package.ConfirmDeactivationMobileNumber": "<div>SIMカード {cardName} の<b>MTX ナンバーサブスクリプション</b>の利用を終了します。</div>",
  "Package.Confirmation": "確認",
  "Package.ConnectPermanently": "常時接続する",
  "Package.Day": "日",
  "Package.Decline": "いいえ",
  "Package.Done": "完了",
  "Package.EnableAnnualRenewal": "Enable automatic renewal",
  "Package.ExpiresDate": "有効期限 {date}",
  "Package.Gb": "GB",
  "Package.GoingToStartRenewal": "\nMTX によって割り当てられたMTX番号は、アカウント残高または保存された支払いカードを使用して同じ期間で自動更新されます。番号の有効期限が切れる前に、十分な残高があることを確認してください。",
  "Package.GoingToStopRenewal": "You are going to stop auto-renewal for MTX Number {number}.",
  "Package.Hour": "時間",
  "Package.IdentityIsNotApproved": "Your idenitiy was not verified. Please contact <a href=\"{link}\">support</a>",
  "Package.IncludeVAT": "VAT{currency} {difference}込",
  "Package.ListIsEmpty": "申し訳ございません。お申し込み頂けるプランがありません。",
  "Package.Mb": "MB",
  "Package.MobileNumberHeader": "MTX SIMカードにMTXナンバーを追加",
  "Package.MobileNumberHint": "MTX ConnectのMTXナンバーを取得すると、世界中どこにいてもMTX SIMでSMSを直接受信できます。",
  "Package.MobileNumberLabel": "Annual subscription for inbound SMS and 2-way voice calls service.",
  "Package.MobileNumberPaymentHint": "お支払いはお客様のMTX Connect残高から差し引かれます。",
  "Package.Number": "番号",
  "Package.PackageWillBeDeactivated": "<strong>ご確認ください！</strong> <strong>{packageName}</strong> プランは終了されます!",
  "Package.PleaseTopup": "残高不足です。{please_topup_page} よりチャージしてください",
  "Package.PleaseTopupPage": "残高チャージページ",
  "Package.PreviousNumbers": "Previous Numbers",
  "Package.SelectNumber": "Select Number",
  "Package.StartRenewal": "Start Renewal",
  "Package.Subscribe": "サブスクライブ",
  "Package.Subscribed": "Subscribed",
  "Package.SubscriptionActivationFailure": "プランをご利用開始できませんでした。時間を置いてお試しください。",
  "Package.SubscriptionDeactivationFailure": "ご利用プランを終了できませんでした。時間を置いてお試しください。",
  "Package.Topup": "チャージ",
  "Package.TopupBalance": "チャージ残高",
  "Package.TrafficWillBeLost": "<strong>ご確認ください！</strong> ご利用中のプランのデータ残量{trafficRemain}Mbは消滅します",
  "Package.Unsubscribe": "サブスクライブをやめる",
  "Package.UnsubscribeWarning": "<p><b>ご注意ください</b></p>\n<p>サブスクリプションの自動更新はキャンセルされます。次の請求日まではサブスクリプションを引き続きご利用いただけますが、以降は自動更新されません。</p>",
  "Package.perMb": "/ MB",
  "Profile.ChangePassword": "パスワードの変更",
  "Profile.ChangingPassword": "パスワード変更中...",
  "Profile.ChooseIdentity": "ファイルを選択",
  "Profile.City": "市区町村郡",
  "Profile.CityHint": "ローマ字で入力",
  "Profile.Common": "一般",
  "Profile.ConfirmNewPassword": "新しいパスワード（確認用）",
  "Profile.CopiedToClipboard": "Copied to your clipboard",
  "Profile.Copy": "紹介リンクをコピー",
  "Profile.Country": "国名",
  "Profile.CurrentPassword": "現在のパスワード",
  "Profile.DeliveryAddress": "住所",
  "Profile.DeliveryType": "Delivery method",
  "Profile.DetailedAddress": "住所詳細",
  "Profile.District": "District",
  "Profile.Email": "メールアドレス",
  "Profile.EmailAddress": "メールアドレス",
  "Profile.FirstName": "名",
  "Profile.FirstNameHint": "ローマ字で入力",
  "Profile.FloorUnit": "アパート/マンション名・部屋番号",
  "Profile.FloorUnitHint": "ローマ字で入力（ビル名またはアパート名いずれか入力必須）",
  "Profile.GetRefferal": "紹介コードを取得",
  "Profile.IdentityPlaceholder": "本人確認書類スキャンのアップロード",
  "Profile.IdentityStatus": "ステータス",
  "Profile.IdentityStatusAccepted": "認証済",
  "Profile.IdentityStatusLoaded": "読み込み完了",
  "Profile.IdentityStatusPending": "アップロード待ち",
  "Profile.IdentityStatusRejected": "拒否されました",
  "Profile.IdentityStatusUnknown": "再アップロードしてください",
  "Profile.IdentityTitle": "インターネットサービスのみをご利用の際は本人確認書類のアップロードは不要です。（※必要に応じてこちらからご依頼する場合もございます。ご了承ください。）SMSナンバーサービス等の電話番号を使ったサービスのご利用にはアップロードが必須となります。\n（サービスを提供するMTX Connect社が本社を置くルクセンブルク大公国が属するEUの反テロ法の一貫として、 本人確認書類（パスポートまたは運転免許証※日本のものでも可）の提示が義務付けられています。）",
  "Profile.LastName": "姓",
  "Profile.LastNameHint": "ローマ字で入力",
  "Profile.Login": "ログイン",
  "Profile.NewPassword": "新しいパスワード",
  "Profile.NoIdentity": "ファイルが選択されていません",
  "Profile.NonLatinError": "英数字および句読点のみ",
  "Profile.PasswordChangeFail": "パスワードの変更ができませんでした",
  "Profile.PasswordChangeSuccess": "パスワードの変更が完了しました",
  "Profile.PasswordsDontMatch": "パスワードが正しくありません",
  "Profile.Phone1": "電話番号",
  "Profile.PhoneHint": "電話番号（国番号+81の後、電話番号の最初の0を抜いて入力してください。）",
  "Profile.PleaseFillNewPassword": "新しいパスワードを入力してください",
  "Profile.PleaseFillPassword": "現在のパスワードを入力してください",
  "Profile.Province": "Province",
  "Profile.Referral": "紹介コード",
  "Profile.Region": "都道府県",
  "Profile.RegionHint": "ローマ字で入力",
  "Profile.Street": "丁目 番地 号",
  "Profile.StreetAndNumber": "Street and Number",
  "Profile.StreetHint": "ローマ字で入力",
  "Profile.StreetNumber": "House",
  "Profile.StreetUnit": "ビル名・部屋番号",
  "Profile.StreetUnitHint": "ローマ字で入力（ビル名またはアパート名いずれか入力必須）",
  "Profile.TermsOfServices": "By clicking \"Next\", you agree to our <a href=\"https://www.mtxc.eu/en/terms-and-conditions.html\" target=\"_blank\">Terms and Conditions</a> and that you have read our <a href=\"https://www.mtxc.eu/en/privacy-policy.html\" target=\"_blank\">Privacy Policy</a>",
  "Profile.TheCurrentPasswordIsIncorrect": "The current password is incorrect",
  "Profile.UpdateFailed": "プロフィールの更新ができませんでした",
  "Profile.UpdateProfile": "プロフィールの更新",
  "Profile.UpdatedSuccessfully": "プロフィールの更新が完了しました！",
  "Profile.UpdatingProfile": "更新中...",
  "Profile.UploadingIdentity": "Uploading:",
  "Profile.ZipCode": "郵便番号",
  "Shared.ActivePackage": "ご利用中のプラン",
  "Shared.ActiveTill": "{date} までご利用可能",
  "Shared.AddSIM": "新しいSIMの追加",
  "Shared.ApiError": "問題が発生しました",
  "Shared.ApiErrorLink": "ページの再読込をしてください",
  "Shared.Back": "戻る",
  "Shared.BonusPackage": "ボーナスプラン",
  "Shared.CardIsSuspended": "このSIMカードのご利用は中断されています。ブロック解除が必要な場合は<a href=\"{link}\">カスタマーサービス</a>までご連絡ください。",
  "Shared.ConnectAndStartUsing": "接続しデータ使用を開始する",
  "Shared.CurrentPackageIs": "ご利用中の {packageName} プランは {date} までご利用可能です",
  "Shared.ErrorGettingTestSmsCount": "テストSMSカウントの取得に失敗しました",
  "Shared.ErrorLoadingPage": "表示できませんでした",
  "Shared.ErrorPhoneMsg": "Please use valid phone number",
  "Shared.FillAllAddressFields": "マークされた箇所を記入してください",
  "Shared.Location": "場所",
  "Shared.NextPackage": "次へ",
  "Shared.PackageToBeActive": "プランはヨーロッパ内でアクティブです：",
  "Shared.Rename": "リネーム",
  "Shared.Sure": "よろしいですか？",
  "Shared.Suspend": "停止",
  "Shared.TestSmsButton": "SMSテスト",
  "Shared.TestSmsLeft": "テストSMS残 {left}",
  "Shared.Unsuspend": "停止の取消は<a href=\"mailto:help@mtxc.eu\">help@mtxc.eu</a>でのみ受け付けています。",
  "Shared.UploadError": "アップロードに失敗しました。本人確認書類を次のメールアドレスに送信してください： support@mtxc.eu ",
  "Shared.UploadWrongFormat": "jpgフォーマットのファイルが必要です",
  "Simcards.ActivateSIM": "新しいSIMの追加",
  "Simcards.ActivateSimCard": "コントロールパネル使用前にSIMカードをアクティベーションする",
  "Simcards.EmptyActivationCode": "Activation Codeを入力してください",
  "Simcards.EnterCode": "Activation Codeを下記に入力してください",
  "Simcards.ErrorLoadingPrices": "Failed to load prices",
  "Simcards.FindActivationCode": "Activation CodeはSIMカード台紙の裏面をご覧ください：",
  "Simcards.SimcardNotActivated": "SIMカードのアクティベーションができませんでした",
  "Simcards.WrongFormatActivationCode": "Activation Codeが無効です",
  "Support.Buffered": "お問い合わせはカスタマーサービスセンターへ送信されました。順次回答致しますので今しばらくお待ちください。回答はメールおよびお客様のアカウントに送信されます。",
  "Support.BufferedCn": "Your message successfully sent to customer service. We will get back to you as soon as possible. The answer will be sent by email/SMS and into your personal account.",
  "Support.CreateCommentError": "お問い合わせ内容の受付ができませんでした。後ほどお試しいただくか、support@mtxc.eu までご連絡ください",
  "Support.CreateTicketError": "お問い合せ件名の受付ができませんでした。後ほどお試しいただくか、support@mtxc.eu までご連絡ください",
  "Support.Date": "日付",
  "Support.LoadMoreBtn": "さらに読み込む",
  "Support.Message": "内容",
  "Support.Send": "送信",
  "Support.Sending": "送信中...",
  "Support.Topic": "件名",
  "TermsAnPrivacy": "By clicking <b>\"Accept\"</b>, I certify that agree to the <a href=\"{terms_url}\" target=\"_blank\"><b>Terms and Conditions</b></a> and <a href=\"{privacy_url}\" target=\"_blank\"><b>Privacy Policy</b></a>.",
  "Topup.AliPay": "アリペイ",
  "Topup.AliPayRedirecting": "アリペイにリダイレクト中...",
  "Topup.AliPayWarning": "アリペイでのお支払の場合、決済確認に最大24時間かかることがございます。<br />今すぐにSIMカードの利用開始をご希望のお客様は他のお支払方法をご選択ください。",
  "Topup.Amount": "チャージ金額",
  "Topup.AmountTitle": "Top-up amount, €",
  "Topup.AmountWord": "Amount {amount} {currency}",
  "Topup.ApplePayBtn": "Buy with",
  "Topup.ByCard": "クレジットカード",
  "Topup.CVC": "CVC",
  "Topup.CardCvv": "Please enter CVV:",
  "Topup.CardDetails": "Card details:",
  "Topup.CardHolderName": "CARDHOLDER NAME",
  "Topup.CardNew": "New card",
  "Topup.CardNumber": "カード番号",
  "Topup.CardSaved": "Saved cards",
  "Topup.EnterVoucherCode": "バウチャーコードを入力",
  "Topup.ExchangeNotice": "為替レートの関係により実際のご請求金額は変動します。ご請求金額が法外な額である場合はお問い合わせよりご連絡ください。",
  "Topup.GettingToken": "処理中...",
  "Topup.InsufficientFunds": "Insufficient funds",
  "Topup.MM": "MM",
  "Topup.MakePayment": "支払う",
  "Topup.Megapay": "890",
  "Topup.PaidWith": "Payé par {paymentMethod}",
  "Topup.PayByVoucher": "バウチャーで支払う",
  "Topup.PayPal": "ペイパル",
  "Topup.PayPalPayment": "ペイパルで支払う",
  "Topup.PayPalProceed": "{amount} {currency_code} をペイパルで支払う",
  "Topup.PaymentInProgress": "支払処理中...",
  "Topup.RefillCard": "お支払いができませんでした。もう一度ご請求先情報を入力してください。申し訳ございませんが、支払いシステム変更のため、残高チャージをご希望のお客様はお支払カード情報を再度ご入力ください。",
  "Topup.RememberCard": "このカードを記憶する",
  "Topup.Saving": "保存中...",
  "Topup.SpecifyAddress": "お支払前にご請求先住所を入力してください",
  "Topup.StoredCard.EnterCVV": "CCVコードを入力してください",
  "Topup.StoredCard.Pay": "支払う",
  "Topup.StoredCard.StoredCards": "記憶済のカード",
  "Topup.StoredCard.UseCard": "このカードを使う",
  "Topup.SubmittingCode": "処理中...",
  "Topup.SuccessfulPaymentDescrEmail": "内容確認メールがメールアドレスに送信されました",
  "Topup.SuccessfulPaymentDescrSMS": "内容確認SMSが送信されました",
  "Topup.SuccessfulPaymentHeader": "お支払が完了しました。",
  "Topup.SuccessfulPaymentPayAgain": "もう一度支払う",
  "Topup.SuccessfulPaymentTransaction": "トランザクションID: {transactionId}",
  "Topup.SuccessfulPaymentTryAgain": "もう一度やり直してください",
  "Topup.TakeCareText": "当社はお客様の安全のために最新の注意を払っております。カード情報の詳細は当社には保管されません。",
  "Topup.UnsuccessfulPaymentHeader": "お支払いができませんでした",
  "Topup.UseCardToAutoSubscriptionRenewal": "Use this card for automatic subscription renewal if there are insufficient funds",
  "Topup.UseCardToAutoTopup": "Use this card for automatic top-up when the balance falls below €2",
  "Topup.ValidThru": "有効期限",
  "Topup.Voucher": "バウチャー",
  "Topup.YY": "YY",
  "autorenew.subscription.disable": "{name} サブスクリプションの自動更新を停止します。",
  "autorenew.subscription.enable": "{name} サブスクリプションは、アカウント残高または保存された支払いカードを使用して同じ期間で自動更新されます。サブスクリプションの有効期限が切れる前に、十分な残高があることを確認してください。",
}



// WEBPACK FOOTER //
// ./app/javascript/components/locales/ja.js